import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: '[appIfscInput]'
})
export class IfscInputDirective {
  constructor(private control: NgControl) {}

  // ✅ Prevent typing invalid characters
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const char = event.key.toUpperCase();
    // Allow only A-Z and 0-9
    if (!char.match(/[A-Z0-9]/)) {
      event.preventDefault();
    }
  }

  // ✅ Also convert pasted input to uppercase and remove invalid chars
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    event.preventDefault();
    const clipboardData = event.clipboardData?.getData('text') ?? '';
    const filtered = clipboardData.toUpperCase().replace(/[^A-Z0-9]/g, '');
    this.control.control?.setValue(filtered);
  }

  // Optional: also handle programmatic input
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    input.value = value;
    this.control.control?.setValue(value, { emitEvent: false });
  }
}